module.exports = "<p>section-style3 works!</p>\n"